import React, { Component } from 'react';
import $ from 'jquery';
import SigninAndUserAc from "../login/SigninAndUserAc";
import OtpInput from 'react-otp-input';
import logout from '../login/Logout';

class OtpVerification extends Component {
  constructor() {
    super();
    this.state = {
      resentOtp: false,
      emailFields: '',
      mobileFields: '',
      checkboxActive: false,
      privacyPolicyCheckboxActive: false,
      errors: {},
      expiryTime: null
    };
  }

  componentDidMount() {
    if (this.props.history.location.state === undefined) {
      this.props.history.push('/signup/step1')
    }
  }

  handleCheckTermsAndCond = (e) => {
    if (e.target.checked) {
      this.setState({ checkboxActive: true });
    } else {
      this.setState({ checkboxActive: false });
    }
  }

  handleCheckPrivacyPoliy = (e) => {
    if (e.target.checked) {
      this.setState({ privacyPolicyCheckboxActive: true });
    } else {
      this.setState({ privacyPolicyCheckboxActive: false });
    }
  }

  heartBeatApi = () => {
    let loginController = this;
    $.ajax({
      url: "/api/app/heartbeat",
      type: 'POST',
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      async: false,
      success: function (res) {
        if (res.success) {
          loginController.state.expiryTime = loginController.state.expiryTime - 300;
          loginController.setState(loginController.state);
        } else {
          logout();
        }
      }
    });
  }

  refreshTokenApi = () => {
    let loginController = this;
    $.ajax({
      url: "/api/app/refresh-token",
      type: 'POST',
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
      async: false,
      success: function (res) {
        if (res.success) {
          localStorage.setItem("access_token", " " + res.authToken);
          localStorage.setItem("expires_in", res.expires_in);
          loginController.state.expiryTime = res.expires_in;
          loginController.setState(loginController.state);
        } else {
          logout();
        }
      }
    });
  }

  submitOtpForm = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      let OtpVerificationController = this;
      let signupdata = this.props.location.state.signupdata;
      let mobileNumber = signupdata["mobileNumber"];
      let username = signupdata["emailId"];
      let passwordVal = signupdata["password"];
      let errors = {};
      let mobileOtp = this.state.mobileFields;
      let emailOtp = this.state.emailFields;

      var otpData = {
        mobileNumber: mobileNumber, mobileNumberOtp: mobileOtp, emailId: username,
        emailOtp: emailOtp, isTermsAndConditionAgreed: this.state.checkboxActive,
        isPrivacyPolicyAgreed: this.state.privacyPolicyCheckboxActive
      }

      $.ajax({
        url: "/api/otp-verification",
        type: 'POST',
        async: false,
        headers: {
          "Content-type": "application/json"
        },
        data: JSON.stringify(otpData),
        success: function (res) {
          if (res.success === true) {
            if (SigninAndUserAc({ username, passwordVal })) {
              OtpVerificationController.getTeamUserActivation();
            }
          } else {
            errors["response"] = res.result;
            OtpVerificationController.setState({
              errors: errors,
              resentOtp: false
            });
          }
        }
      });
    }
  }

  validateForm = () => {
    let emailOtpFields = this.state.emailFields;
    let mobileOtpFields = this.state.mobileFields;
    let errors = {};
    let formIsValid = true;
    if (emailOtpFields.length !== 6) {
      formIsValid = false;
      errors["emailOtp"] = "*Please enter email otp";
    }

    if (mobileOtpFields.length !== 6) {
      formIsValid = false;
      errors["mobileOtp"] = "*Please enter mobile otp";
    }
    this.setState({ errors: errors });
    return formIsValid;
  }

  handleMobileOtpChange = (otp) => {
    let mobileFields = this.state.mobileFields;
    mobileFields = otp;
    this.setState({ mobileFields })
  }

  handleEmailOtpChange = (otp) => {
    let emailFields = this.state.emailFields;
    emailFields = otp;
    this.setState({ emailFields })
  }

  resendOtp = () => {
    let signupdata = this.props.location.state.signupdata;
    let mobileNumber = signupdata["mobileNumber"];
    let username = signupdata["emailId"];
    let OtpVerificationController = this;
    let errors = {};
    let data = { "emailId": username, "mobileNumber": mobileNumber };
    $.ajax({
      url: "/api/resend-otp",
      type: 'POST',
      async: false,
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
      },
      data: data,
      success: function (res) {
        if (res.success === true) {
          OtpVerificationController.setState({ resentOtp: true });
        } else {
          errors["response"] = res.result;
          OtpVerificationController.setState({
            errors: errors,
            resentOtp: false
          });
        }
      }
    });
  }

  routeToTAC = () => {
    var OtpVerificationController = this;
    localStorage.setItem('signupdata', JSON.stringify(OtpVerificationController.props.location.state.signupdata));
    window.open(window.location.origin + '/sales-desk/terms-and-condition', "_blank")
  }

  routeToPrivacyPolicy = () => {
    window.open(window.location.origin + '/sales-desk/privacy-policy', "_blank")
  }

  getTeamUserActivation = () => {
    var otpVerificationComp = this;
    $.ajax({
      url: "/api/team-user-activation",
      async: false,
      method: 'GET',
      data: {
        "userEmail": this.props.location.state.signupdata.emailId
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          otpVerificationComp.props.history.push('/projectmgmt');
        } else {
          otpVerificationComp.props.history.push('/projects/createNewProject');
        }
      },
      error: function (xhr, status, error) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }

  render() {
    return (
      <div className="wrapper">
        <form className="form-horizontal">
          <div className="card-body p-0">
            <div className="row">
              <div className="col-lg-12 p-0">
                <div className="card sign-in-right-tab">
                  <div className="card-body sign-in-page">
                    <div className="col-sm-12">
                      <div className="logoBox mb-5">
                        <img src="./assets/images/dheeai.png" className="mb-2" />
                        <div className="errorMsg" style={{ color: this.state.resentOtp ? "#b2beb5" : 'red' }} name="response">{this.state.resentOtp ? "Otp has been regenerated successfully" : this.state.errors.response}</div>
                      </div>
                    </div>
                    <div className="col-9 p-0 mx-auto ">
                      <div className="step1to3">Step 3 of 3</div> <br />
                      <h5>Enter Email OTP</h5>
                      <div className="row mt-4 mb-4">
                        <OtpInput
                          inputStyle={{
                            width: '3rem',
                            height: '3rem',
                            margin: '0 0.5rem',
                            fontSize: '1rem',
                            borderRadius: 4,
                          }}
                          numInputs={6}
                          onChange={this.handleEmailOtpChange}
                        />
                        <div> <br />
                          <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.emailOtp}</div>
                        </div>
                      </div>

                      <h5>Enter Mobile Number OTP</h5>
                      <div className="row mt-4 mb-4">
                        <OtpInput
                          inputStyle={{
                            width: '3rem',
                            height: '3rem',
                            margin: '0 0.5rem',
                            fontSize: '1rem',
                            borderRadius: 4,
                          }}
                          numInputs={6}
                          onChange={this.handleMobileOtpChange}
                        />
                        <div> <br />
                          <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.mobileOtp}</div>                                    </div>

                      </div>

                      <div className="fpass col-12 p-0">
                        <a style={{ cursor: "pointer", color: "#0094c8" }} onClick={this.resendOtp}>Resend OTP</a>
                      </div>
                      <div className="form-group linktxt">
                        <div className="fpass col-12 p-0" style={{textAlign: 'left', marginLeft: '50%'}}>
                          <label className="mr-5">
                            <input type="checkbox" id="checkboxid" onChange={this.handleCheckTermsAndCond} />
                            <ins className="iCheck-helper" />
                          </label>
                          <span style={{ color: "black" }}>I agree to</span><a className="cursor-change" onClick={this.routeToTAC}> terms and condition </a>
                        </div>
                      </div>
                      <div className="form-group linktxt">
                        <div className="fpass col-12 p-0" style={{textAlign: 'left', marginLeft: '50%'}}>
                          <label className="mr-5">
                            <input type="checkbox" id="checkboxid" onChange={this.handleCheckPrivacyPoliy} />
                            <ins className="iCheck-helper" />
                          </label>
                          <span style={{ color: "black" }}>I agree to</span><a className="cursor-change" onClick={this.routeToPrivacyPolicy}> privacy policy </a>
                        </div>
                      </div>
                      <button type="button" className="btn btn-primary btn-block procBtn" id="otp_proceed_id" disabled={!(this.state.checkboxActive && this.state.privacyPolicyCheckboxActive)} onClick={this.submitOtpForm}>Proceed</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div></form>
      </div>
    );
  }
}
export default OtpVerification;


// WEBPACK FOOTER //
// ./src/sales-desk/signup/OtpVerification.js